import { Link } from 'react-router-dom';

import { EmptyStatePanel } from '@/designSystem/molecules/EmptyStatePanel';

/**
 * Workspace settings stub.
 */
export function SettingsPage() {
  return (
    <div data-testid="agents-settings">
      <header data-testid="agents-settings-header" className="mb-6">
        <h1 className="text-2xl font-semibold text-primary">Settings</h1>
        <p className="mt-2 text-secondary">
          Workspace preferences and integrations will be configured here.
        </p>
      </header>

      <EmptyStatePanel
        data-testid="agents-settings-empty-state"
        icon="Gear"
        title="Settings are on the roadmap"
        description="Tenant configuration, SSO preferences, and API connectors will be added when backend APIs are available."
      />

      <p className="mt-6 text-sm text-secondary">
        Developer reference:{' '}
        <Link to="/design-system" className="ds-link" data-testid="agents-settings-design-system-link">
          Agent builder design system
        </Link>
      </p>
    </div>
  );
}
